<template lang="pug">
  Auth(@loggedIn="onLoggedIn" @loginFailed="onFailedAuthentication")
    div.wrap-application
      ModuleApplication(v-if="uid")
</template>

<style lang="scss" scoped>
.wrap-application {
  width: 100%;
  min-height: 100vh;
  background: #000;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/auth'
import ModuleApplication from '@/components/module/ModuleApplication'
import { database } from '@shared/database'

export default {
  components: {
    Auth,
    ModuleApplication
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    onLoggedIn () {
    
    },
    onHeaderRight () {

    }
  },
  async mounted() {
    // redirect to payment page if user has failed payment
    if (this.uid) {
      const trainee = await database.getTrainee(this.uid)
      if (trainee && !trainee.partnerId && trainee.stripeSubscriptionId && (!trainee.activated || !trainee.paidEntranceFee || !trainee.paidLessonFee)) {
        setTimeout(() => {
          this.$router.push(`/payment`)
        }, 1000)
      }
    }
  }
}
</script>
